module.exports = __webpack_public_path__ + "img/palette-2_fg_cn.310ef16.jpg";